module.exports = __webpack_public_path__ + "media/promo/velle/images/top_products/prod_3-75ac3ffcae54bf50eaee91576fcdf26c.png";